<div class="ts-paginator">
  <div class="ts-paginator-page-size">
    <label class="ts-paginator-label">Items per page:</label>
    <select class="ts-paginator-select"
            [value]="pageSize"
            (change)="onPageSizeChange($event)">
      <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
    </select>
  </div>

  <div class="ts-paginator-range">
    {{ rangeStart }}&ndash;{{ rangeEnd }} of {{ length }}
  </div>

  <div class="ts-paginator-actions">
    <button class="ts-paginator-btn"
            [disabled]="!hasPreviousPage"
            (click)="previousPage()"
            aria-label="Previous page">&lsaquo;</button>
    <button class="ts-paginator-btn"
            [disabled]="!hasNextPage"
            (click)="nextPage()"
            aria-label="Next page">&rsaquo;</button>
  </div>
</div>
